import {
  GET_TYPE_SETTING_PROFILE,
  GET_TYPE_SETTING_PROFILE_FAIL,
  GET_TYPE_SETTING_PROFILE_SUCCESS,
  GET_TYPE_SETTINGS,
  GET_TYPE_SETTINGS_FAIL,
  GET_TYPE_SETTINGS_SUCCESS,
  ADD_NEW_TYPE_SETTING,
  ADD_TYPE_SETTING_SUCCESS,
  ADD_TYPE_SETTING_FAIL,
  UPDATE_TYPE_SETTING,
  UPDATE_TYPE_SETTING_SUCCESS,
  UPDATE_TYPE_SETTING_FAIL,
  DELETE_TYPE_SETTING,
  DELETE_TYPE_SETTING_SUCCESS,
  DELETE_TYPE_SETTING_FAIL,
} from "./actionTypes"

export const getType_settings = ({vendor_type_id,is_active,offset='',page_size=''}) => ({
  type: GET_TYPE_SETTINGS,
  payload:{vendor_type_id,is_active,offset,page_size}
})

export const getType_settingsSuccess = data => ({
  type: GET_TYPE_SETTINGS_SUCCESS,
  payload: data,
})

export const getType_settingsFail = error => ({
  type: GET_TYPE_SETTINGS_FAIL,
  payload: error,
})

export const addNewType_setting = user => ({
  type: ADD_NEW_TYPE_SETTING,
  payload: user,
})

export const addType_settingSuccess = user => ({
  type: ADD_TYPE_SETTING_SUCCESS,
  payload: user,
})  

export const addType_settingFail = error => ({
  type: ADD_TYPE_SETTING_FAIL,
  payload: error,
})

export const updateType_setting = user => ({
  type: UPDATE_TYPE_SETTING,
  payload: user,
})

export const updateType_settingSuccess = user => ({
  type: UPDATE_TYPE_SETTING_SUCCESS,
  payload: user,
})

export const updateType_settingFail = error => ({
  type: UPDATE_TYPE_SETTING_FAIL,
  payload: error,
})

export const deleteType_setting = user => ({
  type: DELETE_TYPE_SETTING,
  payload: user,
})

export const deleteType_settingSuccess = user => ({
  type: DELETE_TYPE_SETTING_SUCCESS,
  payload: user,
})

export const deleteType_settingFail = error => ({
  type: DELETE_TYPE_SETTING_FAIL,
  payload: error,
})

export const getType_settingProfile = () => ({
  type: GET_TYPE_SETTING_PROFILE,
})

export const getType_settingProfileSuccess = userProfile => ({
  type: GET_TYPE_SETTING_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getType_settingProfileFail = error => ({
  type: GET_TYPE_SETTING_PROFILE_FAIL,
  payload: error,
})
